import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Users, Target, Buildings, TrendUp } from "@phosphor-icons/react";

export default function DashboardPanel() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((res) => setData(res.data)).catch(() => {});
  }, []);

  if (!data) return <p className="text-[#71717A]">Loading dashboard...</p>;

  const stats = [
    { key: "total-leads", label: "Total Leads", value: data.total_leads, icon: Target },
    { key: "new-leads", label: "New Leads (7d)", value: data.new_leads_7d, icon: TrendUp },
    { key: "active-clients", label: "Active Clients", value: data.active_clients, icon: Users },
    { key: "corporate-inquiries", label: "Corporate Inquiries", value: data.corporate_leads, icon: Buildings },
  ];

  return (
    <div data-testid="admin-dashboard-panel">
      <h1 className="font-heading text-3xl text-white tracking-tight mb-8">Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        {stats.map((s) => (
          <div key={s.key} data-testid={`stat-card-${s.key}`} className="bg-[#141414] border border-[#27272A] rounded-2xl p-5">
            <s.icon size={22} className="text-[#D4AF37] mb-3" />
            <p className="font-heading text-3xl text-white">{s.value}</p>
            <p className="text-xs text-[#71717A] uppercase tracking-wide mt-1">{s.label}</p>
          </div>
        ))}
      </div>
      <h2 className="font-heading text-xl text-white tracking-tight mb-4">Recent Leads</h2>
      <div className="bg-[#141414] border border-[#27272A] rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[600px]">
          <thead className="text-[#71717A] text-xs uppercase tracking-wide border-b border-[#27272A]">
            <tr>
              <th className="text-left px-5 py-3">Name</th>
              <th className="text-left px-5 py-3">Type</th>
              <th className="text-left px-5 py-3">Contact</th>
              <th className="text-left px-5 py-3">Requested Time</th>
              <th className="text-left px-5 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.recent_leads.map((l) => (
              <tr key={l.id} data-testid={`recent-lead-row-${l.id}`} className="border-b border-[#27272A] last:border-0">
                <td className="px-5 py-3 text-white">{l.name}</td>
                <td className="px-5 py-3 text-[#A1A1AA] capitalize">{l.type}</td>
                <td className="px-5 py-3 text-[#A1A1AA]">{l.email}</td>
                <td className="px-5 py-3 text-[#D4AF37] whitespace-nowrap">{l.preferred_datetime || "-"}</td>
                <td className="px-5 py-3">
                  <span className="text-xs bg-[#D4AF37]/10 text-[#D4AF37] px-2 py-1 rounded-full capitalize">{l.status}</span>
                </td>
              </tr>
            ))}
            {!data.recent_leads.length && (
              <tr>
                <td colSpan={5} className="px-5 py-8 text-center text-[#71717A]">
                  No leads yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
